import React, {useMemo} from "react";
import {cloneDeep, isEmpty} from "lodash";
import {Card, CardHeader, CardTitle, Col, Table} from "reactstrap";
import {FaPencil} from "react-icons/fa6";
import Toggle from "react-toggle";
import Popover from "../../../components/Popover";
import PopoverItem from "../../../components/Popover/PopoverItem";
import ProtectedContent from "../../../components/protectedContent";

const EthernetConfigCard = ({config, onEdit}) => {
  const {name, field_definition = []} = config;

  const orderedFields = useMemo(() => {
    if (isEmpty(field_definition)) return [];
    return cloneDeep(field_definition).sort((a, b) => a.field_order - b.field_order);
  }, [field_definition]);

  const getFieldValue = (value) => {
    if (typeof value === "boolean") {
      return (
        <div className="togglePlacement">
          <Toggle checked={value} />
        </div>
      );
    } else {
      return value;
    }
  };

  return (
    <Col xs={12} sm={12} md={6} lg={4} style={{marginBottom: "10px"}}>
      <Card outline body data-cy={"ethernet-card"}>
        <CardHeader
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "0rem 1.25rem",
          }}
        >
          <CardTitle className="card-title">
            <h3>{name}</h3>
          </CardTitle>
          {/*TODO: need to change permission for edit LAN */}
          <ProtectedContent perms={[]}>
            <div style={{marginRight: "10px"}}>
              <Popover>
                <PopoverItem onContentSelection={onEdit} label={"Edit"} icon={FaPencil} />
              </Popover>
            </div>
          </ProtectedContent>
        </CardHeader>

        <Table className="card-body">
          {orderedFields.map((eachField = {}) => (
            <tr key={eachField.id}>
              <td
                style={{
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  borderTop: "0px",
                }}
              >
                {eachField.field_name}
              </td>
              <td
                style={{
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  borderTop: "0px",
                }}
              >
                {getFieldValue(eachField.field_value)}
              </td>
            </tr>
          ))}
        </Table>
      </Card>
    </Col>
  );
};

export default EthernetConfigCard;
